<article *ngIf="modo === 'cartao'" class="cartao" [style.--cor]="segmento.cor" [style.--fundo]="segmento.fundo"
         (click)="ver.emit(contato)" tabindex="0" (keydown.enter)="ver.emit(contato)">
  <div class="topo">
    <span class="avatar">{{ iniciais }}</span>
    <div class="ident">
      <strong class="nome" [title]="contato.nome">{{ contato.nome || 'Sem nome' }}</strong>
      <span class="tel">{{ telefone }}</span>
    </div>
    <button type="button" class="mia" title="Mensagem com a Mia" (click)="$event.stopPropagation(); mia.emit(contato)"><i class="fe-zap"></i></button>
    <a class="zap" [href]="whatsapp" target="_blank" rel="noopener" title="Conversar no WhatsApp"
       (click)="$event.stopPropagation()"><i class="fab fa-whatsapp"></i></a>
  </div>

  <div class="ritmo" *ngIf="mostraRitmo">
    <div class="barra" [title]="'Costuma pedir a cada ' + ciclo + ' dias'">
      <span class="em-dia" [style.width.%]="fracaoEmDia"></span>
    </div>
    <span class="ritmo-texto">Pede a cada {{ ciclo }} dias · <b>{{ atraso }} {{ atraso === 1 ? 'dia' : 'dias' }} além</b></span>
  </div>

  <ul class="metricas">
    <li><i class="fe-clock"></i>{{ quando }}</li>
    <li *ngIf="pedidos90d"><i class="fe-shopping-bag"></i>{{ pedidosTexto }}</li>
    <li *ngIf="ticket"><i class="fe-tag"></i>ticket {{ ticket }}</li>
  </ul>

  <div class="selo-sem-msg" *ngIf="!recebe"><i class="fe-bell-off"></i>Não recebe campanha</div>
</article>

<div *ngIf="modo === 'linha'" class="linha" [style.--cor]="segmento.cor" [style.--fundo]="segmento.fundo"
     (click)="ver.emit(contato)" tabindex="0" (keydown.enter)="ver.emit(contato)">
  <span class="avatar">{{ iniciais }}</span>

  <div class="ident">
    <strong class="nome" [title]="contato.nome">{{ contato.nome || 'Sem nome' }}</strong>
    <span class="tel">{{ telefone }}<span class="selo-sem-msg" *ngIf="!recebe"><i class="fe-bell-off"></i>não recebe campanha</span></span>
    <span class="resumo-compacto">{{ quando }}<ng-container *ngIf="pedidos90d"> · {{ pedidosTexto }}</ng-container><ng-container *ngIf="mostraRitmo"> · <b>{{ atraso }} {{ atraso === 1 ? 'dia' : 'dias' }} além do ritmo</b></ng-container></span>
  </div>

  <div class="dado">
    <strong>{{ quando }}</strong>
    <span>último pedido</span>
  </div>

  <div class="dado">
    <strong>{{ pedidos90d }} {{ pedidos90d === 1 ? 'pedido' : 'pedidos' }}</strong>
    <span>{{ ticket ? 'ticket ' + ticket : 'em 90 dias' }}</span>
  </div>

  <div class="dado ritmo-linha">
    <ng-container *ngIf="mostraRitmo; else semRitmo">
      <div class="barra"><span class="em-dia" [style.width.%]="fracaoEmDia"></span></div>
      <span><b>{{ atraso }} {{ atraso === 1 ? 'dia' : 'dias' }}</b> além do ritmo de {{ ciclo }}</span>
    </ng-container>
    <ng-template #semRitmo>
      <strong>{{ gasto || '—' }}</strong>
      <span>gasto em 90 dias</span>
    </ng-template>
  </div>

  <div class="acoes">
    <button type="button" class="mia" title="Mensagem com a Mia" (click)="$event.stopPropagation(); mia.emit(contato)"><i class="fe-zap"></i><span>Mia</span></button>
    <a class="zap" [href]="whatsapp" target="_blank" rel="noopener" title="Conversar no WhatsApp"
       (click)="$event.stopPropagation()"><i class="fab fa-whatsapp"></i><span>WhatsApp</span></a>
    <i class="fe-chevron-right seta"></i>
  </div>
</div>
